import React from 'react';
import { StructuredText } from 'react-datocms';
import Image from 'next/legacy/image';
import { H4 } from 'atoms';
import BalanceText from '@/components/BalanceText/BalanceText';

const ResearchContentBlock = ({ heading, img, kicker, content }) => (// NOTE: id = heading for react-scroll library
    <div
        id={heading}
        className='true-wrapper'
    >
        <div
            className='comp-wrapper p-six-four-two'
            data-comp={ResearchContentBlock.displayName}
        >
            {heading && (<span className='mobile-heading px-6'>
                <H4>
                    <BalanceText>
                        {heading}
                    </BalanceText>
                </H4>
            </span>)}

            <div className='img-content-wrapper'>
                <div className='chart-img'>
                    <Image
                        src={img.url}
                        alt={img.alt}
                        width='450'
                        height='467'
                        // layout={'responsive'}
                        // width={img.width}
                        // priority={true}
                        // loading="eager"
                    />
                    {/*
                    <img src={img.url} width={450} height={'auto'} />

                    <Image
                        // lazyLoad={true}
                        // layout='fill'
                        layout='intrinsic'
                        // layout='responsive'
                        // usePlaceholder={true}
                        // data={{ ...img.responsiveImage, bgColor: '#ffffff00' }}
                        data={img.responsiveImage}
                    />
                        */}

                </div>
            </div>

            <div className='text-content-wrapper'>
                <div>
                    {heading && (<span className='desktop-heading'>
                        <H4>{heading}</H4>
                    </span>)}

                    <div className='research-rich-text-block'>
                        <StructuredText data={content} />
                    </div>

                </div>
            </div>

        </div>
        <style jsx>{`
            .comp-wrapper {
                display: flex;
                justify-content: center;
                margin: 0 auto;
                padding: 32px 0px;
                width: 100%;
                max-width: 1300px;
            }

            .true-wrapper:nth-child(odd) {
                background-color: #f9f9f9;
            }

            .chart-img {
                width: 450px;
                position: relative;
            }

            .img-content-wrapper {
                display: flex;
                align-items: center;
            }

            .text-content-wrapper {
                display: flex;
                align-items: center;
                padding: 0px 60px;
                @media (max-width: 991.98px) {
                    padding: 0px 40px;
                }
                @media (max-width: 480px) {
                    padding: 0px 20px;
                }
                width: 700px;
            }

            .research-rich-text-block {
                font-family: 'Avenir', Avenir, -apple-system, BlinkMacSystemFont, 'Segoe UI',
                'Helvetica Neue', sans-serif !important;
                color: #282828 !important;

                h3,
                h4,
                h5,
                h6 {
                    background: -webkit-linear-gradient(#e637a8, #e68037);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }

                img {
                    display: block;
                    margin: 32px auto;
                    max-width: 95%;
                    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2);
                    border-radius: 4px;
                }

                p {
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 24px;
                }
            }

            .mobile-heading {
                display: none;
                padding-left: 20px;
                padding-right: 20px;
                text-align: center;
            }

            @media (max-width: 991.98px) {
                .comp-wrapper {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    margin: 0 auto;
                    padding: 32px 0px;
                    width: 100%;
                    max-width: 1300px;
                }

                .chart-img {
                    display: block;
                    margin: 0 auto;
                    width: 100%;
                    max-width: 450px;
                }

                .text-content-wrapper {
                    width: 100%;
                }

                .desktop-heading {
                    display: none;
                }

                .mobile-heading {
                    display: block;
                    text-align: center;
                }
            }
        `}</style>
    </div>
);

export default ResearchContentBlock;
ResearchContentBlock.displayName = 'ResearchContentBlock';
